/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_LogisticsInputs */

const en_waiting_on_logistics = /** @type {(inputs: Waiting_On_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on Logistics`)
};

/**
* | output |
* | --- |
* | "Waiting on Logistics" |
*
* @param {Waiting_On_LogisticsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_logistics = /** @type {((inputs?: Waiting_On_LogisticsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_LogisticsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_logistics(inputs)
});